import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auxiliaryAuth } from "@/lib/client";
import { Card, CardContent } from "@shared-frontend/components/ui/card";
import { AlertCircle } from "lucide-react";
import {
    Alert,
    AlertDescription,
    AlertTitle,
} from "@shared-frontend/components/ui/alert";
import { Progress } from "@shared-frontend/components/ui/progress";

function AuxiliaryAuthCallbackPage() {
    const [error, setError] = useState<string | undefined>(undefined);
    const navigate = useNavigate();

    useEffect(() => {
        const completeAuth = async () => {
            try {
                await auxiliaryAuth.signIn();
                navigate("/", { replace: true });
            } catch (e: unknown) {
                setError((e as Error).message ?? (e as any));
            }
        };

        completeAuth();
    }, [navigate]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-background">
            <Card className="max-w-md w-full">
                <CardContent className="p-6">
                    {error != null ? (
                        <Alert variant="destructive">
                            <AlertCircle className="h-4 w-4" />
                            <AlertTitle>Authentication Error</AlertTitle>
                            <AlertDescription>{error}</AlertDescription>
                        </Alert>
                    ) : (
                        <div className="text-center">
                            <Progress className="h-8 w-8 mx-auto" />
                            <p className="mt-4 text-muted-foreground">
                                Completing authentication...
                            </p>
                        </div>
                    )}
                </CardContent>
            </Card>
        </div>
    );
}

export default AuxiliaryAuthCallbackPage;
